/**
 * Everything brand-specific lives here. The app is TFWP-only today; data is
 * org-aware (org_id comes from the client's portal_clients row, never from
 * this file), so a second org would only need its own copy of this file and
 * its own deploy.
 *
 * Legal strings mirror supabase/functions/_shared/publicBrand.ts (the source
 * of truth for what a lead-facing page may say about the org).
 */
export const brand = {
  name: "Tax Free Wealth Plan",
  shortName: "TFWP",
  legalName: "Tax Free Wealth Plan LLC",
  siteUrl: "https://www.taxfreewealthplan.com",
  privacyUrl: "https://www.taxfreewealthplan.com/privacy-policy",
  termsUrl: "https://www.taxfreewealthplan.com/terms-of-use",
  supportPhone: "(208) 886-5002",
  supportPhoneHref: "tel:+12088865002",
  logoPath: "/brands/tfwp/logo-color.webp",
  disclosure:
    "Tax Free Wealth Plan LLC is a licensed insurance agency, not a registered investment adviser, broker-dealer, law firm or accounting firm.",
  /** Where magic links land. Must be on the Supabase Auth redirect allow list. */
  appOrigin: (import.meta.env.VITE_APP_ORIGIN as string | undefined) ?? "https://my.taxfreewealthplan.com",
} as const;
